import { connect, } from 'react-redux';
import { AppState, } from '../../sew-core/types';
import GlobalOverlay from '../components/GlobalOverlay';
import { closeOverlay, } from '../../sew-core/actions';

const mapStateToProps = (state: AppState) => ({
  isOpen: state.navigation.globalOverlay.isOpen,
  overlayHeader: state.navigation.globalOverlay.overlayHeader,
});

const mapDispatchToProps = (dispatch) => ({
  closeOverlay: () => dispatch(closeOverlay()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalOverlay);
